import React, { useState, useEffect, useContext } from 'react';
import ReactPlayer from 'react-player';
import { useParams, useNavigate } from 'react-router-dom';
import { LuArrowLeft } from 'react-icons/lu';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Loader from '../../components/Loader';
import LanguageContext, { strings } from '../../contexts/language';
import AuthContext from '../../contexts/auth';
import api from '../../services/api';

import thumb from '../../assets/images/thumb.png';
import thumb_en from '../../assets/images/thumb_en.png';

export default function Salas() {
    const { language } = useContext(LanguageContext);
    const t = strings[language] || strings.pt;
    const { signed } = useContext(AuthContext);
    const navigate = useNavigate();
    const { url } = useParams();

    const [rooms, setRooms] = useState([]);
    const [room, setRoom] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!url) {
            // List all streaming rooms (events with a video link)
            api.post('/posts-event', { lang: language })
               .then(r => { setRooms(r.data.content || []); setLoading(false); })
               .catch(() => setLoading(false));
        } else {
            if (!signed) {
                navigate(`/login?redirect=/sala/${url}`);
                return;
            }
            api.post('/event', { url, lang: language })
               .then(r => { setRoom(r.data.content); setLoading(false); })
               .catch(() => setLoading(false));
        }
    }, [url, language]); // eslint-disable-line

    if (loading) return <div className="page"><Header /><Loader /><Footer /></div>;

    // Single room — streaming view
    if (url) {
        if (!room) return (
            <div className="page"><Header />
                <main style={{ flex:1, padding:'40px 20px', textAlign:'center' }}>
                    <p>{language === 'en' ? 'Room not found.' : 'Sala não encontrada.'}</p>
                    <button className="btn-primary mt-20" onClick={() => navigate('/salas')}>← {t.btn_back || 'Voltar'}</button>
                </main>
                <Footer />
            </div>
        );

        const videoId = language === 'en' ? (room.video_en || room.video) : room.video;
        const title   = language === 'en' ? (room.title_en || room.title) : room.title;

        return (
            <div className="page"><Header />
                <main style={{ flex:1, padding:'20px' }}>
                    <div style={{ maxWidth: 1100, margin: '0 auto' }}>
                        <button className="btn-link d-flex align-items-center gap-2 mb-20"
                                style={{ background:'none', border:'none', cursor:'pointer', color:'#fe2b57', fontWeight:600 }}
                                onClick={() => navigate('/salas')}>
                            <LuArrowLeft size={20} /> {t.btn_back || 'Voltar'}
                        </button>
                        {videoId ? (
                            <div className="embed-container">
                                <ReactPlayer
                                    url={`https://www.youtube.com/watch?v=${videoId}`}
                                    controls playing playsinline width="100%" height="100%"
                                />
                            </div>
                        ) : (
                            <div style={{ padding:'60px 20px', textAlign:'center' }}>
                                <p style={{ fontSize:'1.1rem', color:'#4e4a4d' }}>
                                    {language === 'en' ? 'Stream coming soon.' : 'Transmissão em breve.'}
                                </p>
                            </div>
                        )}
                        <h2 style={{ marginTop: 20, fontWeight: 700, color: '#4e4a4d' }}>{title}</h2>
                        {room.description && (
                            <div className="mt-10" dangerouslySetInnerHTML={{ __html: language === 'en' ? (room.description_en || room.description) : room.description }} />
                        )}
                    </div>
                </main>
                <Footer />
            </div>
        );
    }

    // Rooms listing

    return (
        <div className="page"><Header />
            <main style={{ flex:1, padding:'40px 20px' }}>
                <div style={{ maxWidth: 1100, margin: '0 auto' }}>
                    <h2 className="section-title text-center">{t.salas_title || (language === 'en' ? 'Streaming Rooms' : 'Salas de Transmissão')}</h2>
                    {rooms.length === 0 ? (
                        <div style={{ borderRadius:16,overflow:'hidden',marginTop:20, boxShadow: '0 2px 16px rgba(0,0,0,0.2)' }}>
                            <div className="embed-container">
                                {language === 'en' ?
                                <ReactPlayer
                                    url='https://www.youtube.com/watch?v=9XrQs0KdAhE'
                                    controls playing playsinline width="100%" height="100%"
                                />:
                                <ReactPlayer
                                    url='https://www.youtube.com/watch?v=esJuW2VKkvQ'
                                    controls playing playsinline width="100%" height="100%"
                                />}
                            </div>
                        </div>
                    ) : (
                        <div className="row g-3 mt-20">
                            {rooms.map(ev => (
                                <div key={ev.id} className="col-md-6">
                                    <div className="news-card" style={{ cursor:'pointer' }}
                                         onClick={() => signed ? navigate(`/sala/${ev.url}`) : navigate(`/login?redirect=/sala/${ev.url}`)}>
                                        {ev.image && <img src={ev.image} alt={ev.title} className="news-card-img" />}
                                        <div className="news-card-body">
                                            <h3 className="news-card-title">
                                                {language === 'en' ? (ev.title_en || ev.title) : ev.title}
                                            </h3>
                                            {ev.date_start && (
                                                <p className="news-card-date">
                                                    {new Date(ev.date_start).toLocaleString(language === 'en' ? 'en-US' : 'pt-BR', { day:'2-digit', month:'long', hour:'2-digit', minute:'2-digit' })}
                                                </p>
                                            )}
                                            <span className="btn-primary" style={{ fontSize:'.8rem', padding:'6px 16px' }}>
                                                {language === 'en' ? 'Watch' : 'Assistir'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </main>
            <Footer />
        </div>
    );
}
